import { Navigate, Outlet } from 'react-router';
import { useAuth } from '@/context/auth';
import { Skeleton } from '@/components/ui/Skeleton';

interface ProtectedRouteProps {
  allowedGroups?: string[];
  children?: React.ReactNode;
}

export default function ProtectedRoute({
  allowedGroups,
  children,
}: ProtectedRouteProps) {
  const { user, isLoading, isAuthenticated } = useAuth();

  if (isLoading) {
    return (
      <div className="flex flex-col space-y-3 p-8">
        <div className="grid grid-cols-3 gap-4">
          <Skeleton className="h-[50px]" />
          <Skeleton className="h-[50px]" />
          <Skeleton className="h-[50px]" />
        </div>
        <Skeleton className="w-full h-[125px]" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/sign-in" replace />;
  }

  if (allowedGroups && !user?.isAdmin && allowedGroups.includes('ADMIN')) {
    return <Navigate to="/dashboard" replace />;
  }

  return children ?? <Outlet />;
}

export function AdminRoute({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();

  if (!user?.isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}

export function PublicOnlyRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return null;

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
